import Animation from '../../animations/animation'
import LineTransformer from '../transformers/line-bar-transformer'
import * as ease from 'd3-ease'
import { EPSILON } from 'chart-constants'

/*
 * This animation is used to take a serie that was previously
 * a bar and turn it into a line.
 */
class FromBarAnimation extends Animation {

  constructor (options) {
    super(options)
    // Notice this isn't set as `twoPart: true`. It's because
    // the transformer is a two part animation. This is because
    // the transformer is used by other animations, such as pie <-> line,
    // where bars are an intermediate step

    // Ripple if we're not calculated. If we're calculated, the timings code is busted
    this.ripple = this.chart.layout.breakdown.calculated ? false : true
  }

  match (serie) {
    if (!this.previous.allSerieTypes[serie.id]) {
      return false
    }
    return this.previous.allSerieTypes[serie.id].type === 'bar'
  }

  animate (serie, entering, selection, merged, exiting) {
    // Put the new line in the DOM at the correct position
    this._initialInsert(entering)

    entering.selectAll('path')
            .style('display', 'none') // We don't want to show the path yet

    entering.selectAll('.point')
            .style('opacity', EPSILON)
            .style('display', '')

    let self = this
      , previousSerie = this.previous.allSerieTypes[serie.id].serie
      , transformer = new LineTransformer({
        serie: entering,
        previous: this.previous,
        scalers: this.scalers,
        yScale: this.previous.yScale,
        ease: ease.easeCubicInOut,
        lineScale: this.scalers,
        splitScale: d => {
          return this.scalers.x.groupScale(d.rangeId) + this.serieScale(serie._columnIdx)
        },
        splitWidth: this.serieScale.bandwidth(), // The width of the split lines
        styles: {
          line: {
            stroke: entering.selectAll('path.line.data-line').style('stroke'),
            strokeWidth: entering.selectAll('path.line.data-line').style('stroke-width')
          },
          bar: {
            stroke: previousSerie.selectAll('line').style('stroke'),
            fill: previousSerie.selectAll('rect').style('fill'),
            strokeWidth: previousSerie.selectAll('line').style('stroke-width')
          }
        }
      })

    // Add the split lines as rects
    let splits = transformer.insert(1)

    // Remove the paths from the previous line, but keep the points around
    // The original path is covered by the splitting lines
    previousSerie.selectAll('.rect').remove()

    splits.transition()
          .delay(d => this.timing.delay(d._data))
          .duration(this.timing.duration)
          .ease(ease.easeLinear) // The transformer handles easing.
          .tween('bar', function (d, i) {
            return t => {
              transformer.transform(1 - t, this)
            }
          })
          .end().then(() => {
            entering.selectAll('path')
                    .style('display', '') // Show the full line path
            splits.remove() // Remove the splits when done.
          }).catch(() => {
            // interrupted transition, ignore
          })
  }

}

export default FromBarAnimation
